<template>
    <teleport to="body">
        <div v-show="visible" class="modal-backdrop" @click.self="close">
            <div class="modal-container" role="dialog" aria-modal="true" aria-labelledby="modal-title" aria-describedby="modal-desc">
                  <div class="modal-icon" aria-hidden="true">
                    <!-- Error icon: red circle with white cross -->
                    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="24" cy="24" r="24" fill="#FF0000"/>
                      <path d="M16 16l16 16M32 16L16 32" stroke="#FFFFFF" stroke-width="4" stroke-linecap="round"/>
                    </svg>
                  </div>
                <h2 class="modal-title" :class="'modal-title-' + storeName">{{ title }}</h2>
                <p class="modal-message">{{ message }}</p>
                <button
                    class="modal-btn"
                    :class="'modal-btn-' + storeName"
                    @click="handlePrimary"
                >
                    {{ primaryLabel }}
                </button>
            </div>
        </div>
    </teleport>
</template>

<script>
import { makeSnapshot, PERSIST_KEYS, logSnapshotDebug } from '@/helpers/persistKeys';
import { store } from './store.js';
const LS_KEY = 'imprintUserDataV1';

export default {
    name: 'ErrorModal',
    props: {
        modelValue: { type: Boolean, default: false }
    },
    data() {
        return {
            store: store,
            visible: this.modelValue,
            jqHandler: null,
            title: 'Something went wrong!',
            message: 'The imprint builder ran into an issue. Please reload the page and start again.',
            primaryLabel: 'Reload',
            reloadOnPrimary: true,
            reloadWithoutSave: true,
            storeName: ''
        }
    },
    watch: {
        modelValue(val) { this.visible = val; }
    },
    methods: {
        handlePrimary() {
            if(!this.reloadWithoutSave) {
                try {
                    const snapshot = makeSnapshot(this.store);
                    logSnapshotDebug('BEFORE SAVE', snapshot);
                    localStorage.setItem(LS_KEY, JSON.stringify(snapshot));
                    console.log('[Persist] Saved to', LS_KEY, snapshot);
                    console.log('[Persist] store.js data: ', this.store);
                } catch (e) {
                    console.warn('[Persist] Save failed:', e);
                }
            }

            if (this.reloadOnPrimary) {
                window.location.reload();
            } else {
                this.close();
            }
        },

        handleEvent(e) {
            console.log('[ErrorModal] handleEvent', e?.type, e?.detail);
            const d = e?.detail || {};
            if (d.title) this.title = d.title;
            if (d.message) this.message = d.message;
            if (d.primaryLabel) this.primaryLabel = d.primaryLabel;
            if (typeof d.reloadOnPrimary === 'boolean') this.reloadOnPrimary = d.reloadOnPrimary;
            this.open();
        },

        reload() {
            try {
                // збираємо лише дозволені ключі + прості дані
                const plain = {};
                PERSIST_KEYS.forEach(k => { if (k in store) plain[k] = store[k]; });
                const snapshot = JSON.stringify(plain);
                localStorage.setItem('imprintUserDataV1', snapshot);
            } catch (err) {
                console.error('[ErrorModal] Failed to persist data:', err);
            }
            if (this.reloadOnPrimary) {
                window.location.reload();
            } else {
                this.close();
            }
        },

        open() {
           this.visible = true;
           this.$emit('update:modelValue', true);
        },

        close() {
            this.visible = false;
            this.$emit('update:modelValue', false);
        },
    },
    mounted() {
        console.log('[ErrorModal] mounted, subscribing to events');
        window.addEventListener('add-to-cart-error', this.handleEvent);
        window.addEventListener('imprint-error', this.handleEvent);
        this.storeName = window.PXUTheme.theme_settings.project_store_name;

        /*if (window.jQuery) {
            this.jqHandler = () => this.handleEvent({ type: 'jquery', detail: {} });
            window.jQuery(document).on('add-to-cart-error', this.jqHandler);
            window.jQuery(document).on('imprint-error', this.jqHandler);
        }*/
    },
    unmounted() {
        window.removeEventListener('add-to-cart-error', this.handleEvent);
        window.removeEventListener('imprint-error', this.handleEvent);
        /*
        if (this.jqHandler && window.jQuery) {
            window.jQuery(document).off('add-to-cart-error', this.jqHandler);
            window.jQuery(document).off('imprint-error', this.jqHandler);
        }
        */
    }
}
</script>

<style scoped>
.modal-title.modal-title-mlp {
    font-family: museo, serif;
    color: #009444;
}
.modal-btn.modal-btn-mlp {
    background-color: #009444;
}
.modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2147483647;
}
.modal-container {
    width: 540px;
    height: 230px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 12px 32px rgba(0,0,0,0.16);
}
/*.modal-icon img { width: 50px; height: 50px; object-fit: contain; display:block; }*/
.modal-title {
    font-family: 'Open Sans';
    font-weight: 700;
    font-size: 20px;
    color: #0072bc;
    margin: 0;
}
.modal-message {
    font-family: 'Museo Sans', 'Open Sans', Arial, sans-serif;
    font-size: 12px;
    color: #595959;
    text-align: center;
    margin: 0;
}
.modal-btn {
    background: #0072bc;
    color: #fff;
    border: none;
    padding: 8px 25px;
    font-family: 'Open Sans';
    font-weight: 700;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
}

.modal-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent; /* нічого не фарбуємо під іконкою */
}
.modal-icon svg {
  width: 50px;
  height: 50px;
  display: block;
}

.modal-btn:focus-visible { outline: 3px solid #a8d4f1; outline-offset: 2px; }
</style>
